import reduceEmojis from './reduce_emojis';
import stackFilter from './stack_filter';
import textIndexInStack from './text_index_in_stack';
import findMatches from './find_matches';

export {
    reduceEmojis,
    stackFilter,
    findMatches,
    textIndexInStack
};


// WEBPACK FOOTER //
// ./src/SearchBar/helpers/index.js